import moment from "moment";
import "moment/locale/pt-br";

import Table from "../../Table";
import { ColumnDescription, SelectRowProps } from "react-bootstrap-table-next";

import { IParcelasResponse } from "../../../Interfaces/Cobranca/ParcelasAbertas/ParcelasAbertas";
import SpinnerComponent from "../../Loding/Spinner";
import { formatMoneyReais } from "../../../Tools/FormatTools";
import { useEffect, useState } from "react";
import { ListarParcelasAbertasUAUController } from "../../../Controllers/Cobranca/ParcelasAbertas/ParcelasAbertasController";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome } from "@fortawesome/free-solid-svg-icons";
import { useUserInfor } from "../../../Context/User";

interface IParcelasAbertasCardProps {
    ListParcelas?: Array<IParcelasResponse>;
    ID_CHAVE_ERP?: string;
    mostrarIndicadores?: {
        DS_PRODUTO: string;
        DS_UNIDADE: string;
    };
}

/**
 * ParcelasAbertasCard
 * @params passe a ListParcelas para renderizar as parcelas
 * ou passe o ID_CHAVE_ERP da venda para carregar as parcelas
 * que serão renderizadas.
 * @returns
 */
export default function ParcelasAbertasCard(props: IParcelasAbertasCardProps) {
    const { ID_ORGANIZACAO } = useUserInfor().OrgInfor;
    const perplanMode = "265E272E-B7AB-40FC-B5E9-E5E53BA79CE8";

    const [lstParcelas, setLstParcelas] = useState(props.ListParcelas);
    const [lstSelecionados, setlstSelecionados] = useState<
        Array<IParcelasResponse>
    >([]);
    const [indicadores, setIndicadores] = useState({
        QTD_PARCELAS: 0,
        REAJ: 0,
        ORIGINAL: 0,
        JUROS: 0,
        MULTA: 0,
    });

    useEffect(() => {
        if (!props.ListParcelas && props.ID_CHAVE_ERP) {
            const [NR_EMPRESA, DS_OBRA, NR_VENDA] =
                props.ID_CHAVE_ERP.split("_");
            ListarParcelasAbertasUAUController({
                NR_VENDA: Number.parseInt(NR_VENDA),
                NR_EMPRESA: Number.parseInt(NR_EMPRESA),
                DS_OBRA,
            }).then((res) => {
                setLstParcelas(res);
                if (props.mostrarIndicadores) {
                    setIndicadores({
                        ...res.reduce(
                            (indicadores, parcela) => ({
                                REAJ:
                                    indicadores.REAJ +
                                    parcela.VL_PARCELA_REAJUSTADO,
                                ORIGINAL:
                                    indicadores.ORIGINAL +
                                    parcela.VL_PARCELA_ORIGINAL,
                                JUROS:
                                    indicadores.JUROS + parcela.VL_JUROS_ATRASO,
                                MULTA:
                                    indicadores.MULTA + parcela.VL_MULTA_ATRASO,
                            }),
                            {
                                REAJ: 0,
                                ORIGINAL: 0,
                                JUROS: 0,
                                MULTA: 0,
                            }
                        ),
                        QTD_PARCELAS: res.length,
                    });
                }
            });
        }
    }, [props.ListParcelas, props.ID_CHAVE_ERP, props.mostrarIndicadores]);

    //tabela
    const controlSizePerPage = [2];
    if (lstParcelas && lstParcelas.length > 2)
        controlSizePerPage.push(lstParcelas.length);

    const selectRowProp: SelectRowProps<IParcelasResponse> = {
        mode: "checkbox",
        onSelect: (row, isSelect) => {
            row.FL_MARC = isSelect;
            const lstParcelasMarcadas =
                lstParcelas?.filter((p) => p.FL_MARC) ?? [];
            setlstSelecionados(lstParcelasMarcadas);
        },
        onSelectAll: (isSelect, rows: Array<IParcelasResponse>) => {
            rows.forEach((row) => {
                row.FL_MARC = isSelect;
            });
            const lstParcelasMarcadas =
                lstParcelas?.filter((p) => p.FL_MARC) ?? [];
            setlstSelecionados(lstParcelasMarcadas);
        },
        selected: lstSelecionados.map((selecionados) => {
            return selecionados.ID_CHAVE_PARCELA;
        }),
    };

    let total = {
        parcelaOriginal: 0,
        juros: 0,
        multa: 0,
        total: 0,
        reajuste: 0,
    };
    lstSelecionados.forEach((selecionado) => {
        total.parcelaOriginal += selecionado.VL_PARCELA_ORIGINAL;
        total.juros += selecionado.VL_JUROS_ATRASO;
        total.multa += selecionado.VL_MULTA_ATRASO;
        total.reajuste += selecionado.VL_PARCELA_REAJUSTADO;
        total.total +=
            (perplanMode === ID_ORGANIZACAO ?
                selecionado.VL_PARCELA_REAJUSTADO :
                selecionado.VL_JUROS_ATRASO + selecionado.VL_MULTA_ATRASO + selecionado.VL_PARCELA_ORIGINAL
            )
    });

    const rowTable = (cell: any, row: IParcelasResponse) => {
        const parcela = row;
        return (
            <div
                className={`card card-custom w-auto ml-auto wave wave-animate-slow ${row.FL_N_NEGOCIAR ? "wave-success" : "wave-warning"
                    } border-bottom border-1 border-dark`}
                key={"" + row.DT_VENCIMENTO}
            >
                <div className="card-body p-3">
                    <div className="d-flex align-itens-center justify-content-between mb-1">
                        <h3 className="font-weight-bolder font-size-normal">
                            <span className="text-dark-75">
                                {parcela.DS_TIPO_PARCELA} - {parcela.NR_PARCELA}
                            </span>
                        </h3>
                        <span className="label label-light-primary label-inline mr-2 my-1">
                            Aging {parcela.NR_AGING_PARCELA} Meses
                        </span>
                    </div>
                    <div className="d-flex flex-wrap align-itens-center justify-content-between mb-1">
                        <div className="d-flex flex-wrap flex-column">
                            <span className="d-block font-weight-bold">
                                Data Vencimento
                            </span>
                            <span className="label label-light-primary label-inline mr-2 my-1">
                                {moment(parcela.DT_VENCIMENTO).format("ll")}
                            </span>
                        </div>
                    </div>
                    <div className="d-flex flex-wrap justify-content-between mr-1">
                        <div className="d-flex flex-column mb-1">
                            <span className="text-dark-50 flex-root font-weight-bold">
                                Valor Reajus.
                            </span>
                            <span className="text-dark flex-root font-weight-bold">
                                {formatMoneyReais(
                                    parcela.VL_PARCELA_REAJUSTADO
                                )}
                            </span>
                        </div>
                        <div className="d-flex flex-column mb-1">
                            <span className="text-dark-50 flex-root font-weight-bold">
                                Valor Original
                            </span>
                            <span className="text-dark flex-root font-weight-bold">
                                {formatMoneyReais(parcela.VL_PARCELA_ORIGINAL)}
                            </span>
                        </div>
                        <div className="d-flex flex-column mb-1">
                            <span className="text-dark-50 flex-root font-weight-bold">
                                Multa
                            </span>
                            <span className="text-dark flex-root font-weight-bold">
                                {formatMoneyReais(parcela.VL_MULTA_ATRASO)}
                            </span>
                        </div>
                        <div className="d-flex flex-column mb-1">
                            <span className="text-dark-50 flex-root font-weight-bold">
                                Juros
                            </span>
                            <span className="text-dark flex-root font-weight-bold">
                                {formatMoneyReais(parcela.VL_JUROS_ATRASO)}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        );
    };
    const columns: Array<ColumnDescription> = [
        {
            dataField: "NR_PARCELA_GERAL",
            text: "Títulos Vencidos",
            formatter: rowTable,
            headerClasses: "font-size-h3 font-weight-bold",
            classes: "p-3 ws-nowrap",
        },
    ];
    const tableViewColumns: Array<ColumnDescription<IParcelasResponse>> = [
        {
            dataField: "DS_TIPO_PARCELA",
            text: "Parcela",
            formatter: (c, row) => `${c} - ${row.NR_PARCELA}`,
            classes: (c, row) =>
                `p-3 ws-nowrap ${row.FL_N_NEGOCIAR ? "bg-success-o-40" : ""}`,
            headerAlign: "center",
        },
        {
            dataField: "NR_AGING_PARCELA",
            text: "Aging",
            classes: (c, row) =>
                `p-3 ws-nowrap ${row.FL_N_NEGOCIAR ? "bg-success-o-40" : ""}`,
            align: "center",
            headerAlign: "center",
        },
        {
            dataField: "DT_VENCIMENTO",
            text: "Data de Vencimento",
            formatter: (c) => new Date(c).toLocaleDateString(),
            classes: (c, row) =>
                `p-3 ws-nowrap ${row.FL_N_NEGOCIAR ? "bg-success-o-40" : ""}`,
            align: "center",
            headerAlign: "center",
        },
        {
            dataField: "DT_PRORROGACAO",
            text: "Data de Prorrogação",
            formatter: (c, row) => {
                var DataPro = new Date(c).toLocaleDateString();

                if (DataPro !== "01/01/1") return DataPro;
                else return "-";
            },
            //formatter: (c) => (new Date(c).toLocaleDateString()),
            classes: (c, row) =>
                `p-3 ws-nowrap ${row.FL_N_NEGOCIAR ? "bg-success-o-40" : ""}`,
            align: "center",
            headerAlign: "center",
        },
        {
            dataField: "VL_PARCELA_REAJUSTADO",
            text: "Valor Reajus.",
            formatter: (c) => formatMoneyReais(c),
            classes: (c, row) =>
                `p-3 ws-nowrap ${row.FL_N_NEGOCIAR ? "bg-success-o-40" : ""}`,
            align: "center",
            headerAlign: "center",
        },
        {
            dataField: "VL_PARCELA_ORIGINAL",
            text: "Valor Principal",
            formatter: (c) => formatMoneyReais(c),
            classes: (c, row) =>
                `p-3 ws-nowrap ${row.FL_N_NEGOCIAR ? "bg-success-o-40" : ""}`,
            align: "center",
            headerAlign: "center",
        },
        {
            dataField: "VL_MULTA_ATRASO",
            text: "Multa",
            formatter: (c) => formatMoneyReais(c),
            classes: (c, row) =>
                `p-3 ws-nowrap ${row.FL_N_NEGOCIAR ? "bg-success-o-40" : ""}`,
            align: "center",
            headerAlign: "center",
        },
        {
            dataField: "VL_JUROS_ATRASO",
            text: "Juros",
            formatter: (c) => formatMoneyReais(c),
            classes: (c, row) =>
                `p-3 ws-nowrap ${row.FL_N_NEGOCIAR ? "bg-success-o-40" : ""}`,
            align: "center",
            headerAlign: "center",
        },
    ];

    return (
        <>
            {props.mostrarIndicadores && lstParcelas && (
                <>
                    <div className="d-flex flex-wrap justify-content-between mb-2">
                        <div className="d-flex">
                            <div
                                className={`pr-2 symbol symbol-45 symbol-light-danger`}
                            >
                                <div className="symbol-label">
                                    <FontAwesomeIcon icon={faHome} size="lg" />
                                </div>
                            </div>
                            <div>
                                <h5 className="font-weight-bolder mb-0">
                                    {props.mostrarIndicadores.DS_PRODUTO}
                                </h5>
                                <p>{props.mostrarIndicadores.DS_UNIDADE}</p>
                            </div>
                        </div>
                        {indicadores.QTD_PARCELAS} Parcelas em Aberto
                    </div>
                    <div className="card card-custom w-auto mb-2 p-2">
                        <div className="d-flex flex-wrap justify-content-around mr-1">
                            <div className="d-flex flex-column mb-1 align-items-center p-2">
                                <span className="text-dark-50 flex-root font-weight-bold">
                                    Valor Reajus.
                                </span>
                                <span className="text-dark flex-root font-weight-bold">
                                    {formatMoneyReais(indicadores.REAJ)}
                                </span>
                            </div>
                            <div className="d-flex flex-column mb-1 align-items-center p-2">
                                <span className="text-dark-50 flex-root font-weight-bold">
                                    Valor Principal
                                </span>
                                <span className="text-dark flex-root font-weight-bold">
                                    {formatMoneyReais(indicadores.ORIGINAL)}
                                </span>
                            </div>
                            <div className="d-flex flex-column mb-1 align-items-center p-2">
                                <span className="text-dark-50 flex-root font-weight-bold">
                                    Multa
                                </span>
                                <span className="text-dark flex-root font-weight-bold">
                                    {formatMoneyReais(indicadores.MULTA)}
                                </span>
                            </div>
                            <div className="d-flex flex-column mb-1 align-items-center p-2">
                                <span className="text-dark-50 flex-root font-weight-bold">
                                    Juros
                                </span>
                                <span className="text-dark flex-root font-weight-bold">
                                    {formatMoneyReais(indicadores.JUROS)}
                                </span>
                            </div>
                        </div>
                    </div>
                </>
            )}
            <div className="card card-custom w-auto gutter-b p-6">
                {lstParcelas ? (
                    <>
                        <Table
                            data={lstParcelas}
                            columns={columns}
                            keyField="ID_CHAVE_PARCELA"
                            bordered={false}
                            noSearch
                            noHover
                            selectRow={selectRowProp}
                            rowClasses="text-danger"
                            sizePerPage={2}
                            controlSizePerPage={controlSizePerPage}
                            noDataIndication={() => (
                                <div className="text-black-50 text-center">
                                    Nenhuma parcela vencida
                                </div>
                            )}
                            paginationColor="Cobranca"
                            tableView={{
                                columns: tableViewColumns,
                            }}
                        />
                        <div className="d-flex flex-column justify-content-between align-items-center border border-dark">
                            <div
                                className="font-weight-bold"
                                style={{
                                    fontSize: 17,
                                    textAlign: "center",
                                }}
                            >
                                Parcelas Selecionadas
                            </div>
                            <div className="d-flex justify-content-between g-2">
                                <span
                                    className="font-weight-bold ml-2"
                                    style={{
                                        fontSize: 15,
                                        textAlign: "center",
                                    }}
                                >
                                    Valor Total: {formatMoneyReais(total.total)}
                                </span>
                                <span
                                    className="font-weight-bold"
                                    style={{
                                        fontSize: 15,
                                        textAlign: "center",
                                    }}
                                >
                                    Valor Reajuste:{" "}
                                    {formatMoneyReais(total.reajuste)}
                                </span>
                                <span
                                    className="font-weight-bold"
                                    style={{
                                        fontSize: 15,
                                        textAlign: "center",
                                    }}
                                >
                                    Multa Total: {formatMoneyReais(total.multa)}
                                </span>
                                <span
                                    className="font-weight-bold"
                                    style={{
                                        fontSize: 15,
                                        textAlign: "center",
                                    }}
                                >
                                    Juros Total: {formatMoneyReais(total.juros)}
                                </span>

                                <span
                                    className="font-weight-bold mr-2"
                                    style={{
                                        fontSize: 15,
                                        textAlign: "center",
                                    }}
                                >
                                    Valor Original Total:{" "}
                                    {formatMoneyReais(total.parcelaOriginal)}
                                </span>
                            </div>
                        </div>
                    </>
                ) : (
                    <SpinnerComponent />
                )}
            </div>
        </>
    );
}
